"use client"
/* */
const columnLayoutContainer = "flow--column-layout--column-layout-container";
const columnLayout = "flow--column-layout";
const styles = {
	columnLayoutContainer: columnLayoutContainer,
	columnLayout: columnLayout,
	"hide-l-1": "flow--column-layout--hide-l-1",
	"hide-l-2": "flow--column-layout--hide-l-2",
	"hide-l-3": "flow--column-layout--hide-l-3",
	"hide-l-4": "flow--column-layout--hide-l-4",
	"hide-l-5": "flow--column-layout--hide-l-5",
	"hide-m-1": "flow--column-layout--hide-m-1",
	"hide-m-2": "flow--column-layout--hide-m-2",
	"hide-m-3": "flow--column-layout--hide-m-3",
	"hide-m-4": "flow--column-layout--hide-m-4",
	"hide-m-5": "flow--column-layout--hide-m-5",
	"hide-s-1": "flow--column-layout--hide-s-1",
	"hide-s-2": "flow--column-layout--hide-s-2",
	"hide-s-3": "flow--column-layout--hide-s-3",
	"hide-s-4": "flow--column-layout--hide-s-4",
	"hide-s-5": "flow--column-layout--hide-s-5"
};

export { columnLayout, columnLayoutContainer, styles as default };
//# sourceMappingURL=ColumnLayout.module.scss.mjs.map
